import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';
import { UserView } from './UserView';
import type { Option } from 'gossamer-unified';

type ForumOption = Option & { entityId: string };
export const ForumTypes: ForumOption[] = [
  { id: 'Event', label: 'Event', entityId: 'Event' },
  { id: 'EventHost', label: 'Event Host', entityId: 'Event' },
  { id: 'Institution', label: 'Institution', entityId: 'Institution' },
  { id: 'InstitutionGroup', label: 'Institution Group', entityId: 'InstitutionGroup' },
  { id: 'OrgUnit', label: 'Org Unit', entityId: 'OrgUnit' },
  { id: 'UserView', label: 'User', entityId: 'UserView' },
];

export const getForumEntityId = (forumType: string): string | undefined =>
  ForumTypes.find((f) => f.id === forumType)?.entityId ?? 'UserView';

export interface ConvoRow {
  id: number;
  subject_text: string;
  institution_id: number;
  forum_type: string;
  forum_key: string;
  latest_message_id: number;
  latest_message_at: string;
  recipient_user_id: string;
  created_by: string;
  created_at: string;
}

export const Convo: Entity<ConvoRow> = {
  id: 'Convo',
  title: 'Convo',
  service: 'main',
  rowLabel: (row: ConvoRow) => row.subject_text,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.convo',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  defaultSort: [['latest_message_at', 'DESC']],
  defaultFilters: [{ fieldId: 'subject_text', operator: 'eq', value: '' }],
  listRowLink: '/admin/convo/inbox/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    subject_text: {
      seq: 10,
      type: FieldType.Text,
      label: 'Subject',
      mandatory: true,
      listColumn: true,
    },
    institution_id: {
      seq: 15,
      label: 'Institution',
      type: FieldType.Reference,
      refEntity: Institution,
    },
    forum_type: {
      seq: 20,
      label: 'Forum Type',
      type: FieldType.Options,
      options: ForumTypes,
    },
    forum_key: {
      seq: 25,
      label: 'Forum Key',
      type: FieldType.Text,
    },
    latest_message_id: {
      seq: 30,
      label: 'Latest Message Id',
      type: FieldType.Integer,
    },
    latest_message_at: {
      seq: 35,
      label: 'Latest Message Sent At',
      type: FieldType.Datetime,
      listColumn: true,
    },
    recipient_user_id: {
      seq: 40,
      label: 'Recipient',
      type: FieldType.Reference,
      refEntity: UserView,
      description: 'For conversations between two specific users',
    },
    created_by: {
      seq: 45,
      label: 'Created By',
      type: FieldType.Reference,
      refEntity: UserView,
      listColumn: true,
    },
    created_at: {
      seq: 50,
      label: 'Created At',
      type: FieldType.Datetime,
    },
  },
};
